import { render } from "./ChatMessageBox.vue?vue&type=template&id=02026e14&scoped=true&ts=true"
import script from "./ChatMessageBox.vue?vue&type=script&lang=ts"
export * from "./ChatMessageBox.vue?vue&type=script&lang=ts"

import "./ChatMessageBox.vue?vue&type=style&index=0&id=02026e14&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02026e14"]])

export default __exports__